
































































































import {Component, Ref, Vue} from 'vue-property-decorator';
import JdiPreview from "@/components/JdiPreview.vue"
import JdsButton from "@/design-system/components/Button/JdsButton.vue"
import JdiStatus from "@/components/JdiStatus.vue"
import JdiContent from "@/components/JdiContent.vue"
import JdsConfirmation from "@/design-system/patterns/Confirmation/JdsConfirmation.vue"
import JdiDoNot from "@/components/JdiDoNot.vue"
import JdiCodeBlock from "@/components/JdiCodeBlock.vue"
import JdiDocs from "@/components/JdiDocs.vue"

@Component({
    components: {JdiDocs, JdsConfirmation, JdiPreview, JdsButton, JdiStatus, JdiContent, JdiDoNot, JdiCodeBlock}
})
export default class Confirmation extends Vue {

    @Ref() basicDemoEl!: JdsConfirmation;
    @Ref() customButtonDemoEl!: JdsConfirmation;

    openBasicDemo () {
        (this.basicDemoEl as JdsConfirmation).confirm()
            .then((resp: UIEvent) => console.log('confirmed', resp))
            .catch((resp: UIEvent) => console.log('canceled', resp))
            .finally(() => console.log('closed'));
    }

    openCustomButtonDemo () {
        this.customButtonDemoEl.confirm()
            .then((resp: UIEvent) => console.log('confirmed', resp))
            .catch((resp: UIEvent) => console.log('canceled', resp))
            .finally(() => console.log('closed'));
    }
}
